import { Component, inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { fadeInAnimation } from '../../../../animations';
import { AdminDefinitions } from '../../../../core/store/admin/admin-definitions/admin-definitions.interface';
import * as actions from '../../../../core/store/admin/users/users.actions';
import { ClientUser, EditUser } from '../../../../core/store/admin/users/users.interface';
import { BaseContainer } from '../../../base/BaseContainer';
import { ScrollService } from '../../../../core/services/scroll.service';
import { goAction } from '../../../../core/store/router/router.actions';
import { takeWhile } from 'rxjs/operators';

@Component({
  selector: 'admin-customer-client-edit',
  templateUrl: './client-user-edit.container.html',
  styleUrls: ['./client-user-edit.container.scss'],
  animations: [fadeInAnimation],
})
export class ClientUserEditContainer extends BaseContainer implements OnInit {
  readonly = false;
  editUser: EditUser;
  adminDefinitions: AdminDefinitions;

  private route = inject(ActivatedRoute);
  private dialog = inject(MatDialog);
  private scrollService = inject(ScrollService);

  constructor() {
    super();
    this.route.data.pipe(takeWhile(() => !this.destroyed)).subscribe(data => (this.readonly = !!data.readonly));
    this.store
      .select('admin')
      .pipe(takeWhile(() => !this.destroyed))
      .subscribe((admin: any) => {
        this.editUser = admin.edit;
        this.adminDefinitions = admin.adminDefinitions;
      });
  }

  ngOnInit(): void {
    this.scrollService.scrollToElement('top');
  }

  cancelClicked() {
    this.store.dispatch(goAction({ path: '/admin/clientUsers' }));
  }

  updateUser(user: ClientUser) {
    this.store.dispatch(new actions.ClientUserUpdateAction(user));
  }

  salesOrganisationIdSelected(salesOrganisationId: string) {
    this.store.dispatch(new actions.ClientUserLoadSoldTosAction({ salesOrganisationId }));
  }

  soldToIdSelected(soldToId: string) {
    this.store.dispatch(new actions.ClientUserLoadShipTosAction({ soldToId }));
  }

  inviteUser(clientUser: ClientUser) {
    // Only implemented in client-user-invite.container
  }

  createUser(clientUser: ClientUser) {
    this.store.dispatch(new actions.ClientUserCreateAction(clientUser));
  }

  reInvite(userId: string) {
    this.store.dispatch(new actions.UserReInviteAction({ userId, overviewUrl: '/admin/clientUsers' }));
  }

  resetPassword(userId: string) {
    this.store.dispatch(new actions.UserResetPasswordAction({ userId, overviewUrl: '/admin/clientUsers' }));
  }
}
